import { SVGProps } from 'react';

export const SvgCoupons = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M10.8337 4.16602V5.83268M10.8337 14.166V15.8327M10.8337 9.16602V10.8327M1.66699 7.49935C2.33003 7.49935 2.96592 7.76274 3.43476 8.23158C3.9036 8.70042 4.16699 9.33631 4.16699 9.99935C4.16699 10.6624 3.9036 11.2983 3.43476 11.7671C2.96592 12.236 2.33003 12.4993 1.66699 12.4993V14.166C1.66699 14.608 1.84259 15.032 2.15515 15.3445C2.46771 15.6571 2.89163 15.8327 3.33366 15.8327H16.667C17.109 15.8327 17.5329 15.6571 17.8455 15.3445C18.1581 15.032 18.3337 14.608 18.3337 14.166V12.4993C17.6706 12.4993 17.0347 12.236 16.5659 11.7671C16.0971 11.2983 15.8337 10.6624 15.8337 9.99935C15.8337 9.33631 16.0971 8.70042 16.5659 8.23158C17.0347 7.76274 17.6706 7.49935 18.3337 7.49935V5.83268C18.3337 5.39065 18.1581 4.96673 17.8455 4.65417C17.5329 4.34161 17.109 4.16602 16.667 4.16602H3.33366C2.89163 4.16602 2.46771 4.34161 2.15515 4.65417C1.84259 4.96673 1.66699 5.39065 1.66699 5.83268V7.49935Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
